import styled from 'styled-components'
import { isMobile } from '../../../../services/breakpoints.service'

export const StyledUpdate = styled.div`
	padding: 3rem 0;

	.accordion {
		margin-top: 4rem;
	}

	.dica {
		font-size: 15px;
	}
`

export const StyledButtons = styled.div`
	display: flex;
	flex-direction: row-reverse;

	button {
		min-width: 32%;
		margin-right: 5px;
		&:last-child {
			padding-left: 1rem;
			padding-right: 1rem;
		}
	}
`

export const ContainerBenefit = styled.div`
	display: flex;
	flex-direction: column;
`

export const ContainerBenfitType = styled.div`
	display: flex;
	flex-direction: row;
	gap: 20px;
`

export const StyledInputContainer = styled.div`
	margin-bottom: 3rem;
	align-self: center;
	width: 100%;
`

export const StyledSeparatorOrangeLine = styled.div`
	margin: 2rem 0 2rem 0;
	border-bottom: 1px solid #d4622f;
	line-height: 2em;
`

/**
 * @param {int} columns
 *
 */
export const getGridWith3Col = (columns) => {
	return isMobile()
		? {}
		: {
				display: 'grid',
				gridGap: '15px',
				gridTemplate: `repeat(${columns}, auto) / repeat(3, 1fr)`,
		  }
}
